import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import OrderApi from './OrderApi';
import Order from '../../models/Order';
import { Basket, compileBasket, basketLine } from '../../models/Basket';
import { setAlert } from '../alert/actions'
import { RootState } from '../';
import { getExpectedRevision, readRevisionFromApiValue } from './orderRevision';
import { readHttpErrorStatus, isHttpNotFound } from '../../utils/httpErrorUtils';
import {
    clearStaleStoredOrderIfMissingFromOpenOrders,
    clearStoredOrderId,
    hasActiveOrderSession,
    isActiveOrderInOpenOrders,
    isActiveOrderRoute,
    isOrderLoadedInState,
    readOrderIdFromPath,
    resolveActiveOrderIdFromState,
} from '../../utils/orderRouteUtils';
import { recordBackgroundPoll } from '../../utils/backgroundSyncMetrics';
import { markOpenOrdersRefreshed } from '../../utils/openOrdersPollCoordinator';
import { ORDER_REVISION_POLL_INTERVAL_SECONDS } from '../../config/backgroundSyncConfig';

import {
    IGetOrder,
    ISetOrder,
    ICreateOrder,
    IGetOpenOrders,
    IGetClosedOrders,
    IGetBasket,
    IApplyChanges,
    IApplyBasketChanges,
    IResetBasketChanges,
    IGetShops,
    IPeakNavOrders,
    IOpenNavOrder,
    IGetCustomerShippingAdresses,
    IIsfetchingShippingAdresses,
    ISetFetching,
    IDashboardIsFetching,
    IGetDashboardData,
    IDashboardState,
    ISetDashboardDeliveryWindows,
    ISetOrderDeleted,
    IClearOrder,
    IAddRecentClosedOrder,
    IRemoveClosedOrderFromRecent,
    IApplyOrder,
    IOrderIsPending,
    ISetOrderNotFound,
    IClearDashboard,
    IUserIsInformed,
    INavOrdersOpen,
    INavOrdersClosed,
    IOrdersFullyShipped,
    IAllClosedOrdersIsPending,
    IAllOpenOrdersIsPending,
    IOrderRemoteSync,
    ISetCollabSyncUi,
    ICollabSyncUi,
    IRequestCollabSyncCheck,
    IEndCollabMode,
    ICollabActiveStateChanged,
    IActivityFabVisibilityChanged,
    ILeaveOrderFromCollab,
    IShowOrderRevisionConflict,
    IHideOrderRevisionConflict,
    IOrderRevisionLogEntry,
    ISetOrderActivityEntries,
    IAppendOrderActivityEntries,
    ISetOrderActivityLoading,
    ISetHighlightOrderLine,
    IClearOrderActivity,
    IRemoteOrderUnavailable,
    RemoteOrderUnavailableReason,
} from './orderStore';

import * as helper from '../../components/shared/Dashboard/DashboardHelper';

// import DeliveryWindows from '../../components/shared/Dashboard/DeliveryWindows';

// Action Creators
export const getOrderSucces = (order: Order): IGetOrder => {
    return { type: 'GET_ORDER_SUCCESS', order }
}

export const getDashboardOrderStateSuccess = (dashboardData: IDashboardState): IGetDashboardData => {
    return { type: 'GET_DASHBOARD_DATA_SUCCESS', dashboardData}
}

export const clearDashBoard = (): IClearDashboard => {
    return { type: 'CLEAR_DASHBOARD'}
}

export const getShopsSuccess = (shops: any[]): IGetShops => {
    return { type: 'GET_SHOPS_SUCCESS', shops }
}

export const setOrderSucces = (order: Order): ISetOrder => {
    return { type: 'SET_ORDER_SUCCESS', order }
}

export const addClosedOrderToRecent = (order: any): IAddRecentClosedOrder => {
    return { type: 'ADD_CLOSED_ORDER_TO_RECENT', order }
}

export const removeClosedOrderFromRecentSuccess = (closedOrders: any[]): IRemoveClosedOrderFromRecent => {
    return { type: 'REMOVE_CLOSED_ORDER_TO_RECENT', closedOrders }
}

export const setDeliveryWindowsSuccess = (dashboardDeliveryWindows: any[]): ISetDashboardDeliveryWindows => {
    return { type: 'SET_DASHBOARD_DELIVERY_WINDOWS_SUCCESS', dashboardDeliveryWindows }
}

export const getOpenOrdersSuccess = (orders: any[]): IGetOpenOrders => {
    return { type: 'GET_OPEN_ORDERS_SUCCESS', orders }
}

export const getClosedOrdersSuccess = (closedOrders: any[]): IGetClosedOrders => {
    return { type: 'GET_CLOSED_ORDERS_SUCCESS', closedOrders }
}

export const peakNavOrdersSuccess = (navOrders: any[]): IPeakNavOrders => {
    return { type: 'PEAK_NAV_ORDER_SUCCESS', navOrders }
}

export const navOrdersClosedSuccess = (orders: any[]): INavOrdersClosed => {
    return { type: 'NAV_ORDER_CLOSED_SUCCESS', orders }
}

export const navOrdersOpenSuccess = (orders: any[]): INavOrdersOpen => {
    return { type: 'NAV_ORDER_OPEN_SUCCESS', orders }
}

export const fullyShippedOrdersSuccess = (orders: any[]): IOrdersFullyShipped => {
    return { type: 'ORDERS_FULLY_SHIPPED_SUCCESS', orders }
}

export const openNavOrderSuccess = (navOrder: any): IOpenNavOrder => {
    return { type: 'OPEN_NAV_ORDER_SUCCESS', navOrder }
}

export const createOrderSucces = (order: Order): ICreateOrder => {
    return { type: 'CREATE_ORDER_SUCCESS', order }
}

export const getBasketSuccess = (basket: Basket): IGetBasket => {
    return { type: 'GET_BASKET_SUCCESS', basket }
}

export const applyChangesSuccess = (): IApplyChanges => {
    return { type: 'APPLY_CHANGES_SUCCESS' }
}

export const applyBasketChangesSuccess = (changes: basketLine): IApplyBasketChanges => {
    return { type: 'APPLY_BASKET_CHANGES_SUCCESS', changes }
}

export const resetBasketChangesSuccess = (): IResetBasketChanges => {
    return { type: 'RESET_BASKET_CHANGES_SUCCESS', changes: {} }
}

export const getCustomerShippingAddressesSuccess = (addresses: any[]): IGetCustomerShippingAdresses => {
    return { type: 'GET_CUSTOMER_SHIPPING_ADDRESSES_SUCCESS', shippingAddresses:  addresses }
}

export const setIsFetchingShippingAddresses = (isFetching: boolean): IIsfetchingShippingAdresses => {
    return { type: 'SET_FETCHING_SHIPPING', isFetching }
}

export const setIsDashboardFetching = (isDashboardFetching: boolean): IDashboardIsFetching => {
    return { type: 'DASHBOARD_IS_FETCHING', isDashboardFetching }
}

export const setFetching = (isFetching: boolean): ISetFetching => {
    return { type: 'SET_FETCHING_ORDER', isFetching }
}

//ISetOrderDeleted
export const orderDeletedSuccess = (orderId: number): ISetOrderDeleted => {
    return { type: 'ORDER_DELETED_SUCCESS', orderId }
}

//IClearOrder
export const clearActiveOrder = (): IClearOrder => {
    return { type: 'CLEAR_ACTIVE_ORDER' }
}

export const applyOrderSuccess = (): IApplyOrder => {
    return { type: 'ORDER_COMPLETED_SUCCESS' }
}

export const setOrderIsPending = (isPending: boolean): IOrderIsPending => {
    return { type: 'ORDER_IS_PENDING', payload: isPending }
}

export const setAllOpenOrderIsPending = (isPending: boolean): IAllOpenOrdersIsPending => {
    return { type: 'ALL_OPEN_ORDERS_IS_PENDING', payload: isPending }
}

export const setAllOpenClosedIsPending = (isPending: boolean): IAllClosedOrdersIsPending => {
    return { type: 'ALL_CLOSED_ORDERS_IS_PENDING', payload: isPending }
}

export const setOrderNotFound = (notFound: boolean): ISetOrderNotFound => {
    return { type: 'SET_ORDER_NOT_FOUND', payload: notFound }
}

export const setUserIsInformed = (informed: boolean): IUserIsInformed => {
    return { type: 'ORDER_USER_IS_INFORMED', payload: informed }
}

export const orderRemoteSyncSuccess = (): IOrderRemoteSync => {
    return { type: 'ORDER_REMOTE_SYNC' }
}

export const DEFAULT_COLLAB_SYNC_UI: ICollabSyncUi = {
    status: 'hidden',
    secondsRemaining: ORDER_REVISION_POLL_INTERVAL_SECONDS,
    pollIntervalSeconds: ORDER_REVISION_POLL_INTERVAL_SECONDS,
    nextCheckAt: null,
    checkNonce: 0,
    lastUpdatedAt: null,
    writeResetNonce: 0,
}

export const setCollabSyncUi = (ui: ICollabSyncUi): ISetCollabSyncUi => {
    return { type: 'SET_COLLAB_SYNC_UI', payload: ui }
}

export const requestCollabSyncCheck = (): IRequestCollabSyncCheck => {
    return { type: 'REQUEST_COLLAB_SYNC_CHECK' }
}

export const endCollabMode = (): IEndCollabMode => {
    return { type: 'END_COLLAB_MODE' }
}

export const collabActiveStateChanged = (): ICollabActiveStateChanged => {
    return { type: 'COLLAB_ACTIVE_STATE_CHANGED' }
}

export const activityFabVisibilityChanged = (): IActivityFabVisibilityChanged => {
    return { type: 'ACTIVITY_FAB_VISIBILITY_CHANGED' }
}

export const leaveOrderFromCollab = (): ILeaveOrderFromCollab => {
    return { type: 'LEAVE_ORDER_FROM_COLLAB' }
}

export const showOrderRevisionConflict = (): IShowOrderRevisionConflict => {
    return { type: 'SHOW_ORDER_REVISION_CONFLICT' }
}

export const hideOrderRevisionConflict = (): IHideOrderRevisionConflict => {
    return { type: 'HIDE_ORDER_REVISION_CONFLICT' }
}

export const setOrderActivityEntries = (entries: IOrderRevisionLogEntry[]): ISetOrderActivityEntries => ({
    type: 'SET_ORDER_ACTIVITY_ENTRIES',
    payload: entries,
})

export const appendOrderActivityEntries = (entries: IOrderRevisionLogEntry[]): IAppendOrderActivityEntries => ({
    type: 'APPEND_ORDER_ACTIVITY_ENTRIES',
    payload: entries,
})

export const setOrderActivityLoading = (isLoading: boolean): ISetOrderActivityLoading => ({
    type: 'SET_ORDER_ACTIVITY_LOADING',
    payload: isLoading,
})

export const setHighlightOrderLine = (lineId: number | null): ISetHighlightOrderLine => ({
    type: 'SET_HIGHLIGHT_ORDER_LINE',
    payload: lineId,
})

export const clearOrderActivity = (): IClearOrderActivity => ({
    type: 'CLEAR_ORDER_ACTIVITY',
})

export const remoteOrderUnavailable = (
    reason: RemoteOrderUnavailableReason
): IRemoteOrderUnavailable => ({
    type: 'REMOTE_ORDER_UNAVAILABLE',
    payload: reason,
})

const getMaxActivityRevision = (entries: IOrderRevisionLogEntry[]): number | null => {
    if (!entries.length) {
        return null;
    }
    return entries.reduce((max, entry) => Math.max(max, entry.revisionNumber), 0);
}

export interface FetchOrderActivityLogOptions {
    incremental?: boolean;
    remoteRevision?: number | null;
}

export const fetchOrderActivityLog = (
    orderId: number,
    options?: FetchOrderActivityLogOptions
): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<void> => {
        try {
            const currentEntries = getState().order.order.orderActivity.entries;
            const sinceRevision = options && options.incremental
                ? getMaxActivityRevision(currentEntries)
                : null;

            if (
                options &&
                options.incremental &&
                sinceRevision != null &&
                options.remoteRevision != null &&
                options.remoteRevision <= sinceRevision
            ) {
                return;
            }

            if (!options || !options.incremental) {
                dispatch(setOrderActivityLoading(true));
            }

            const response = await OrderApi.getOrderRevisionLog(
                orderId,
                sinceRevision != null ? sinceRevision : undefined,
                50
            );
            recordBackgroundPoll('Order/GetOrderRevisionLog');

            const entries: IOrderRevisionLogEntry[] = (response.data && response.data.entries) || [];

            if (sinceRevision != null && entries.length) {
                dispatch(appendOrderActivityEntries(entries));
            } else if (!sinceRevision) {
                dispatch(setOrderActivityEntries(entries));
            } else {
                dispatch(setOrderActivityLoading(false));
            }
        } catch (e) {
            if (isHttpNotFound(e)) {
                dispatch(setOrderNotFound(true));
                dispatch(clearOrderActivity());
                const orderState = getState().order.order;
                if (isOrderLoadedInState(orderState, orderId)) {
                    dispatch(remoteOrderUnavailable('deleted'));
                }
                return;
            }
            dispatch(setOrderActivityLoading(false));
        }
    }
}

export const refreshOrderActivityIfNeeded = (
    orderId: number,
    remoteRevision: number | null | undefined
): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<void> => {
        if (remoteRevision == null) {
            return;
        }

        const currentEntries = getState().order.order.orderActivity.entries;
        const maxLogged = getMaxActivityRevision(currentEntries);

        if (maxLogged != null && remoteRevision <= maxLogged) {
            return;
        }

        await dispatch(fetchOrderActivityLog(orderId, {
            incremental: maxLogged != null,
            remoteRevision,
        }));
    }
}

export interface ApplyOrderFromServerOptions {
    fromDashboard?: boolean
    resetBasket?: boolean
    markAutoUpdate?: boolean
}

export const markAutoUpdateWriteSuccess = (): ThunkAction<void, RootState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState) => {
        const collabSyncUi = getState().order.order.collabSyncUi || DEFAULT_COLLAB_SYNC_UI;
        dispatch(setCollabSyncUi({
            ...collabSyncUi,
            lastUpdatedAt: Date.now(),
            writeResetNonce: collabSyncUi.writeResetNonce + 1,
        }));
    }
}

export const applyOrderFromServerResponse = (
    order: Order,
    options?: ApplyOrderFromServerOptions
): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<void> => {
        const state = getState().order.order;

        if (options && options.fromDashboard) {
            dispatch(getDashboardOrderStateSuccess({
                dashboardOrder: order,
                dashboardDeliveryWindows: state.dashboardDeliveryWindows || [],
            }));
        }

        dispatch(setOrderSucces(order));
        dispatch(getBasket(order));
        dispatch(orderRemoteSyncSuccess());

        if (options && options.resetBasket !== false) {
            await dispatch(resetBasketChanges());
        }

        if (options && options.markAutoUpdate !== false) {
            dispatch(markAutoUpdateWriteSuccess());
        }

        const orderId = order.orderheader && order.orderheader.appOrderId;
        if (orderId) {
            dispatch(refreshOrderActivityIfNeeded(orderId, getExpectedRevision(order)));
        }
    }
}

export const parseOrderRevisionConflict = (error: any): Order | null => {
    const data = error && error.response ? error.response.data : null;
    if (!data) {
        return null;
    }
    return data.order || data.Order || null;
}

export const isOrderRevisionConflict = (error: any): boolean =>
    !!(error && error.response && error.response.status === 409);

export const handleOrderWriteError = (
    error: any,
    dispatch: ThunkDispatch<RootState, {}, AnyAction>,
    options?: { fromDashboard?: boolean }
): boolean => {
    if (!isOrderRevisionConflict(error)) {
        return false;
    }

    const order = parseOrderRevisionConflict(error);
    if (order) {
        dispatch(applyOrderFromServerResponse(order, {
            fromDashboard: options && options.fromDashboard,
            markAutoUpdate: false,
        }));
    }

    dispatch(showOrderRevisionConflict());
    return true;
}

export const getActiveOrderFromState = (state: RootState): Order | undefined =>
    state.order.order.order || state.order.order.dashboardOrder;

const resolveExpectedRevision = async (orderId: number, order?: Order): Promise<number> => {
    const fromOrder = getExpectedRevision(order);
    if (fromOrder != null) {
        return fromOrder;
    }

    const response = await OrderApi.getOrderRevision(orderId);
    const data = response.data || {};
    const revision = readRevisionFromApiValue(data.revision != null ? data.revision : data.Revision);
    return revision != null ? revision : 0;
};

export interface SyncOrderFromRemoteOptions {
    fromDashboard?: boolean
    showToast?: boolean
    notifyAutoUpdate?: boolean
}

export const syncOrderFromRemote = (
    orderId: number,
    options?: SyncOrderFromRemoteOptions
): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<void> => {
        try {
            if (options && options.fromDashboard) {
                await dispatch(getDashboardOrderState(orderId));
            } else {
                await dispatch(setOrder(orderId));
            }
            await dispatch(resetBasketChanges());
            dispatch(orderRemoteSyncSuccess());
            dispatch(markAutoUpdateWriteSuccess());
            if (options && options.showToast) {
                dispatch(setAlert('Order synced with latest changes', 'success'));
            } else if (options && options.notifyAutoUpdate) {
                dispatch(setAlert('Order updated from another session', 'success'));
            }

            const order = getActiveOrderFromState(getState());
            await dispatch(refreshOrderActivityIfNeeded(orderId, getExpectedRevision(order)));
        } catch (e) {
            // Transient sync errors retry on next poll.
        }
    }
}

export const evaluateActiveOrderAvailability = (): ThunkAction<void, RootState, {}, AnyAction> => {
    return (dispatch, getState) => {
        const orderState = getState().order.order;
        const pathname = window.location.pathname;

        if (orderState.orderIsPending || orderState.isFetching || orderState.isDashboardFetching) {
            return;
        }

        const activeId = resolveActiveOrderIdFromState(orderState, pathname);
        if (!activeId || !isActiveOrderRoute(pathname)) {
            return;
        }

        if (!hasActiveOrderSession(orderState, pathname, activeId)) {
            return;
        }

        if (isActiveOrderInOpenOrders(orderState.orders, activeId)) {
            return;
        }

        const loadedHeader =
            orderState.order && orderState.order.orderheader && orderState.order.orderheader.appOrderId === activeId
                ? orderState.order.orderheader
                : orderState.dashboardOrder &&
                  orderState.dashboardOrder.orderheader &&
                  orderState.dashboardOrder.orderheader.appOrderId === activeId
                    ? orderState.dashboardOrder.orderheader
                    : null;

        if (!loadedHeader) {
            const pathOrderId = readOrderIdFromPath(pathname);
            clearStoredOrderId();
            if (pathOrderId === activeId) {
                dispatch(remoteOrderUnavailable('unavailable'));
            }
            return;
        }

        const reason: RemoteOrderUnavailableReason =
            loadedHeader.orderState !== 0 ? 'closed' : 'deleted';

        dispatch(remoteOrderUnavailable(reason));
    };
};

export const getOpenOrders = (): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<void> => {
        if (getState().order.order.allOpenOrdersPending) {
            return;
        }

        try {
            dispatch(setAllOpenOrderIsPending(true));
            const response = await OrderApi.getOpenOrders();
            recordBackgroundPoll('Order/GetMyOpenOrders');
            dispatch(getOpenOrdersSuccess(response.data));
            clearStaleStoredOrderIfMissingFromOpenOrders(response.data, getState().order.order);
            dispatch(evaluateActiveOrderAvailability());
            markOpenOrdersRefreshed();
        } catch (e) {
            // Transient errors retry on next refresh.
        } finally {
            dispatch(setAllOpenOrderIsPending(false));
        }
    }
}

export const applyOrder = (orderId: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            dispatch(setOrderIsPending(true))
            await OrderApi.applyOrder(orderId);
            localStorage.removeItem('order')
            const response = await OrderApi.getOpenOrders();
            dispatch(clearActiveOrder())
            dispatch(getOpenOrdersSuccess(response.data))
            dispatch(setOrderIsPending(false))
        } catch (e) {}
    }
}

export const clearShop = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            localStorage.removeItem('order')
            const response = await OrderApi.getOpenOrders();
            dispatch(clearActiveOrder())
            dispatch(getOpenOrdersSuccess(response.data))
        } catch (e) {}
    }
}

const handleActiveOrderLoadFailure = (
    dispatch: ThunkDispatch<RootState, {}, AnyAction>,
    getState: () => RootState,
    error: unknown
): boolean => {
    const storedId = readStoredOrderId();
    clearStoredOrderId();

    if (isHttpNotFound(error)) {
        const orderState = getState().order.order;
        if (storedId != null && isOrderLoadedInState(orderState, storedId)) {
            dispatch(remoteOrderUnavailable('deleted'));
        }
        return true;
    }

    return false;
}

export const getClosedOrders = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            const response = await OrderApi.getClosedOrders();
            dispatch(getClosedOrdersSuccess(response.data))
        } catch (e) {}
    }
}

export const addRecentClosedOrder = (customerId: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            const response = await OrderApi.peakNavOrders(customerId);
            dispatch(peakNavOrdersSuccess(response.data))
        } catch (e) {}
    }
}

export const peakNavOrders = (customerId: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            const response = await OrderApi.peakNavOrders(customerId);
            dispatch(peakNavOrdersSuccess(response.data))
        } catch (e) {}
    }
}

export const getAllClosedNavOrders = (customerId: number, allShops: boolean = false): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            dispatch(setAllOpenClosedIsPending(true))
            const response = await OrderApi.getAllClosedOrders(customerId, allShops);
            dispatch(navOrdersClosedSuccess(response))
            dispatch(setAllOpenClosedIsPending(false))
        } catch (e) {}
    }
}

export const getAllOpenNavOrders = (customerId: number, allShops: boolean = false): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            dispatch(setAllOpenOrderIsPending(true))
            const response = await OrderApi.getAllOpenOrders(customerId, allShops);
            dispatch(navOrdersOpenSuccess(response))
            dispatch(setAllOpenOrderIsPending(false))
        } catch (e) {}
    }
}

export const getShops = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            const response = await OrderApi.getShops();
            dispatch(getShopsSuccess(response.data))
        } catch (e) {}
    }
}

export const getOrder = (orderId: number): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<void> => {
        try {
            
            dispatch(setFetching(true));
            dispatch(setOrderNotFound(false))
            const response = await OrderApi.getOrder(orderId);

            if (response.data.orderheader.orderState === 1 && !response.data.orderheader.navImportRef) {
                await dispatch(clearShop());
            } else {
                dispatch(getOrderSucces(response.data))
                dispatch(getBasket(response.data));
                dispatch(setFetching(false));
            }
        } catch (e) {
            dispatch(setFetching(false));
            if (handleActiveOrderLoadFailure(dispatch, getState, e)) {
                return;
            }

            dispatch(setAlert('Order is probably shipped', 'error'))
            await dispatch(clearShop());
            dispatch(setOrderNotFound(true));
        }
    }
}

export const setOrder = (orderId: number): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<void> => {
        try {
            dispatch(setFetching(true));
            dispatch(setOrderNotFound(false))
            const response = await OrderApi.getOrder(orderId);

            if (response.data.orderheader.orderState === 1 && !response.data.orderheader.navImportRef) {
                await dispatch(clearShop());
            } else {
                localStorage.setItem('order', String(orderId))           
            
                dispatch(setOrderSucces(response.data))
                dispatch(getBasket(response.data));
                dispatch(setFetching(false));
            }
            
        } catch (e) {
            dispatch(setFetching(false));
            if (handleActiveOrderLoadFailure(dispatch, getState, e)) {
                return;
            }

            dispatch(setAlert('Order is probably shipped', 'error'))
            await dispatch(clearShop());
            dispatch(setOrderNotFound(true));
        }
    }
}

export const setDashboardDeliveryWindows = (appOrderId: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {

            const response = await OrderApi.getOrderDeliveries(appOrderId);

            // const dashboardDeliveryWindows = helper.getDeliveryWindows(orderlines);
            dispatch(setDeliveryWindowsSuccess(response.data));
            
        } catch (e) {}
    }
}

// addClosedOrderToRecent
export const addClosedOrderToRecentAction = (order: any): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        
        try {
            const recentClosedOrders = localStorage.getItem('recentClosedOrders')
            let found = [];
            let orders = []

            if (recentClosedOrders) {
                orders = JSON.parse(recentClosedOrders);
                
                found = orders.map((item: any) => {
                    return item.appOrderId === order.orderheader.appOrderId
                })[0];
            }

            if (!found && order.orderheader.navImportRef && order.orderheader.orderState !== 0 && order.orderheader.orderIsFinal) {
                orders.push(order.orderheader)
            }

            localStorage.setItem('recentClosedOrders', JSON.stringify(orders))

            dispatch(addClosedOrderToRecent(order.orderheader));
        } catch (e) {}
    }
}

export const removeClosedOrderToRecentAction = (appOrderId: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        
        try {
            const recentClosedOrders = OrderApi.removeRecentOrdersFromLocalStorage(appOrderId)
            const activeOrderId = localStorage.getItem('order')

            dispatch(removeClosedOrderFromRecentSuccess(recentClosedOrders));

            if (activeOrderId && appOrderId === +activeOrderId) {
                localStorage.removeItem('order')
                dispatch(clearActiveOrder())

                dispatch(orderDeletedSuccess(appOrderId))
                dispatch(getOpenOrders())
            }

            dispatch(setAlert('Order has been closed', 'success'))
            
        } catch (e) {}
    }
}

export const createOrder = (orderType: string, customerId: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            const response = await OrderApi.createOrder(orderType, customerId);
            dispatch(createOrderSucces(response.data));
        } catch (e) {}
    }
}

export const openNavOrderAndSetOrder = (navOrderId: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            const response = await OrderApi.openNavOrder(navOrderId);
            dispatch(openNavOrderSuccess(response.data));
            dispatch(setOrder(response.data.createdapporderid));
        } catch (e) {}
    }
}

export const createAndSetOrder = (orderType: string, customerId: number, salespersonNote?: string): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            const createdOrder = await OrderApi.createOrder(orderType, customerId);
            const appOrderId = createdOrder.data.appOrderId;

            await dispatch(setOrder(appOrderId));

            if (salespersonNote && salespersonNote.trim() !== '') {
                await dispatch(updateOrder({
                    appOrderId,
                    salespersonNote
                }));
            }

            await dispatch(getOpenOrders());
        } catch (e) {
            console.error('createAndSetOrder failed', e);
            dispatch(setAlert('Could not create or activate order', 'error'));
            throw e;
        }
    }
}

export const deleteOrder = (orderId: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        try {
            const activeOrderId = localStorage.getItem('order')
            await OrderApi.deleteOrder(orderId);

            if (activeOrderId && +activeOrderId === orderId) {
                localStorage.removeItem('order')
                dispatch(clearActiveOrder())
            }

            dispatch(setAlert('Order has been deleted', 'success'))

            dispatch(orderDeletedSuccess(orderId))
            dispatch(getOpenOrders())
            
        } catch (e) {}
    }
}

export const getBasket = (order: Order): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        const basket: Basket = compileBasket(order);
        dispatch(getBasketSuccess(basket));
    }
}

export const applyChanges = (orderId: number, changes: basketLine): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<void> => {
        if (!Object.keys(changes).length) {
            return;
        }

        const order = getActiveOrderFromState(getState());
        const expectedRevision = await resolveExpectedRevision(orderId, order);

        try {
            dispatch(setFetching(true));
            const response = await OrderApi.applyChanges(orderId, changes, expectedRevision);

            if (response && response.data) {
                await dispatch(applyOrderFromServerResponse(response.data));
            }

            dispatch(setAlert('New items added to basket', 'success'))
        }
        catch (e) {
            if (!handleOrderWriteError(e, dispatch)) {
                console.log(e, 'ERROR');
            }
        } finally {
            dispatch(setFetching(false));
        }
    }
}

export const applyChangesFromDashboard = (orderId: number, changes: basketLine): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<void> => {
        if (!Object.keys(changes).length) {
            return;
        }

        const order = getActiveOrderFromState(getState());
        const expectedRevision = await resolveExpectedRevision(orderId, order);

        try {
            dispatch(setFetching(true));
            dispatch(setIsDashboardFetching(true));
            const response = await OrderApi.applyChanges(orderId, changes, expectedRevision);

            if (response && response.data) {
                await dispatch(applyOrderFromServerResponse(response.data, { fromDashboard: true }));
            }

            dispatch(setAlert('New items added to basket', 'success'))
        } catch (e) {
            if (!handleOrderWriteError(e, dispatch, { fromDashboard: true })) {
                console.log(e, 'ERROR');
            }
        } finally {
            dispatch(setFetching(false));
            dispatch(setIsDashboardFetching(false));
        }
    }
}

export const updateOrder = (data: any, options?: { fromDashboard?: boolean }): ThunkAction<Promise<boolean>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<boolean> => {
        const order = getActiveOrderFromState(getState());
        const expectedRevision = await resolveExpectedRevision(data.appOrderId, order);
        const payload = { ...data, expectedRevision };

        try {
            const response = await OrderApi.updateOrder(payload);

            if (response && response.data && response.data.orderheader) {
                await dispatch(applyOrderFromServerResponse(response.data, {
                    fromDashboard: options && options.fromDashboard,
                }));
            }

            return true;
        } catch (e) {
            if (handleOrderWriteError(e, dispatch, { fromDashboard: options && options.fromDashboard })) {
                return false;
            }
            throw e;
        }
    }
}

export const moveOrderDelivery = (
    orderId: number,
    deliveryCode: string,
    newDate: string,
    options?: { fromDashboard?: boolean }
): ThunkAction<Promise<boolean>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<boolean> => {
        const order = getActiveOrderFromState(getState());
        const expectedRevision = await resolveExpectedRevision(orderId, order);

        try {
            const response = await OrderApi.moveOrderDelivery(orderId, deliveryCode, newDate, expectedRevision);

            if (response && response.data && response.data.orderheader) {
                await dispatch(applyOrderFromServerResponse(response.data, {
                    fromDashboard: options && options.fromDashboard,
                }));
            }

            return true;
        } catch (e) {
            if (handleOrderWriteError(e, dispatch, { fromDashboard: options && options.fromDashboard })) {
                return false;
            }
            throw e;
        }
    }
}

export const ensureOrderStockChanges = (
    orderId: number,
    confirmChange: boolean = false
): ThunkAction<Promise<any>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState) => {
        const order = getActiveOrderFromState(getState());
        const expectedRevision = confirmChange
            ? await resolveExpectedRevision(orderId, order)
            : null;

        try {
            const response = await OrderApi.ensureOrderStockChanges(orderId, confirmChange, expectedRevision);

            if (confirmChange && response && response.data && response.data.orderheader) {
                await dispatch(applyOrderFromServerResponse(response.data, { fromDashboard: true }));
            }

            return response;
        } catch (e) {
            if (handleOrderWriteError(e, dispatch, { fromDashboard: true })) {
                return null;
            }
            throw e;
        }
    }
}

export const applyBasketChanges = (changes: basketLine): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        dispatch(applyBasketChangesSuccess(changes));
    }
}

export const resetBasketChanges = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        dispatch(resetBasketChangesSuccess());
    }
}

export const resetDashboard = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        dispatch(clearDashBoard());
    }
}

export const getCustomerShippingAddresses = (customerId: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        dispatch(setIsFetchingShippingAddresses(true));
        const response = await OrderApi.getCustomerShippingAddresses(customerId);
        dispatch(getCustomerShippingAddressesSuccess(response.data));
        dispatch(setIsFetchingShippingAddresses(false));
    }
}

export const getDashboardOrderState = (orderId: number, shouldAddToRecent?: boolean): ThunkAction<Promise<void>, RootState, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<RootState, {}, AnyAction>, getState): Promise<void> => {
        try {
            dispatch(setIsDashboardFetching(true));
            dispatch(setFetching(true));
            dispatch(setOrderNotFound(false))
            
            const response = await OrderApi.getOrder1(orderId);
            
            localStorage.setItem('order', String(orderId)) 

            if (response.data.orderheader.orderState === 1 && !response.data.orderheader.navImportRef) {
                await dispatch(clearShop());
            } else {
                localStorage.setItem('order', String(orderId)) 

                const dashboardOrder = response.data;
                
                dispatch(getDashboardOrderStateSuccess({
                    dashboardOrder,
                    dashboardDeliveryWindows: [],
                }))

                dispatch(addClosedOrderToRecentAction(dashboardOrder))
                dispatch(setDashboardDeliveryWindows(dashboardOrder.orderheader.appOrderId))
                dispatch(setIsDashboardFetching(false));
                
                dispatch(setOrderSucces(response.data))
                dispatch(getBasket(response.data));
                dispatch(setFetching(false));
            }
            
        } catch (e) {
            dispatch(setIsDashboardFetching(false));
            dispatch(setFetching(false));

            if (handleActiveOrderLoadFailure(dispatch, getState, e)) {
                return;
            }

            await dispatch(clearShop());
            dispatch(setOrderNotFound(true));
        }
    }
}

export const setUserHasConfirmed = (informed: boolean): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        localStorage.setItem('gotIt', JSON.stringify(informed));
        dispatch(setUserIsInformed(informed));
    }
}